module.exports = __webpack_public_path__ + "img/footerlogo.be0dc8d8.png";